// extracted by mini-css-extract-plugin
module.exports = {"ProductWrapper":"VisualNav_ProductWrapper___vAot"};